import { apiSlice } from "@redux/apiSlice";

export const eventApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getEvents: build.query({
      query: () => `public/virtual-events/all-events`,
    }),
    getEventData: build.query({
      query: (data) =>
        `/public/virtual-events/${data?.section}/${data?.event_slug}`,
    }),
    eventNewsletter: build.mutation({
      query: (data) => ({
        url: `/public/virtual-events/email-reserve`,
        method: "POST",
        body: { slug: data?.slug, letterEmail: data?.letterEmail },
      }),
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetEventDataQuery,
  useEventNewsletterMutation,
} = eventApi;
